import Profile from '../../pages/Profile'
import Support from '../../pages/Support'
import { permissions } from '../../types/authorization'
import type { ProtectedRouteDescriptor } from '../types'

export const profileRoutes: ProtectedRouteDescriptor[] = [
  {
    key: 'profile',
    path: 'profile',
    element: <Profile />,
    access: { anyOf: [permissions.viewProfile] },
  },
  {
    key: 'settings',
    path: 'settings',
    element: <Profile />,
    redirectTo: '/profile',
  },
  {
    key: 'support',
    path: 'support',
    element: <Support />,
    access: { anyOf: [permissions.requestSupport] },
  },
  {
    key: 'login-logout',
    path: 'login/logout',
    element: <Profile />,
    redirectTo: '/logout',
  },
]
